import type { CSSProperties } from 'react'
import type { BorderRadiusCorners } from '../data/v1'

export function borderRadiusStyle(borderRadius: number, corners: BorderRadiusCorners): CSSProperties {
	return {
		borderTopLeftRadius: corners.topLeft ? borderRadius : 0,
		borderTopRightRadius: corners.topRight ? borderRadius : 0,
		borderBottomRightRadius: corners.bottomRight ? borderRadius : 0,
		borderBottomLeftRadius: corners.bottomLeft ? borderRadius : 0,
	}
}
